import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const balanceApi = createApi({
  reducerPath: 'balanceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/order/',
    prepareHeaders: (headers, { getState }) => {
      let { auth: { auth } } = getState();
      if (typeof auth == "string") {
        auth = JSON.parse(auth);
      }
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  tagTypes: ["balance"],
  endpoints: (builder) => ({
    getBalance: builder.query({
      query: () => `balance`,
      providesTags: ["balance"],
    }),
    createOrUpdateBalance: builder.mutation({
      query: (formData) => {
        return {
          url: `balance`,
          method: 'post',
          body: formData
        }
      },
      invalidatesTags: ["balance"],
    }),
    addBalence: builder.mutation({
      query: (formData) => {
        return {
          url: `balance-add`,
          method: 'post',
          body: formData
        }
      },
      invalidatesTags: ["balance"],
    }),
  }),
})
export const { useGetBalanceQuery, useCreateOrUpdateBalanceMutation, useAddBalenceMutation } = balanceApi